module.exports = __webpack_public_path__ + "static/media/default_cashback.08bd6428.svg";